<template>
  <v-container class="pa-0" :class="{ 'appbar-touchable': touchable }">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-badge
          :content="chatUnreadCount"
          :value="chatUnreadCount > 0"
          color="error"
          overlap
        >
          <v-btn
            style="width: auto; height: auto"
            icon
            :class="{ 'appbar-touchable__btn': touchable }"
            v-bind="attrs"
            v-on="on"
            @click="openDrawer"
          >
            <my-icon
              name="message-icon"
              :stroke="
                touchable
                  ? $vuetify.theme.isDark
                    ? '#fff'
                    : '#455A64'
                  : $vuetify.theme.isDark
                    ? '#fff'
                    : '#000'
              "
              :fill="touchable ? undefined : $vuetify.theme.isDark ? '#fff' : '#000'"
              :width="touchable ? 22 : 18"
              :height="touchable ? 22 : 18"
              :cursor-pointer="true"
            />
          </v-btn>
        </v-badge>
      </template>
      <span>{{ $t("conversations") }}</span>
    </v-tooltip>
  </v-container>
</template>

<script>
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";

const CHAT_TYPES = [
  { ui: "personal", api: "direct" },
  { ui: "group", api: "group" },
  { ui: "channel", api: "channel" },
  { ui: "ticket", api: "ticket" },
];

export default {
  components: {
    MyIcon,
  },
  props: {
    touchable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      unreadFetchTimer: null,
      unreadFetchToken: 0,
      initialUnreadReady: false,
    };
  },
  computed: {
    chatUnreadCount() {
      return Number(this.$store.state.chatUnreadCount) || 0;
    },
  },
  created() {
    if (this.$root) {
      this.$root.$on("chat-live-event", this.onChatLiveEvent);
      this.$root.$on("chat-unread-refresh", this.onChatLiveEvent);
    }
  },
  mounted() {
    this.fetchChatUnreadCount();
  },
  beforeDestroy() {
    if (this.$root) {
      this.$root.$off("chat-live-event", this.onChatLiveEvent);
      this.$root.$off("chat-unread-refresh", this.onChatLiveEvent);
    }
    if (this.unreadFetchTimer) {
      clearTimeout(this.unreadFetchTimer);
      this.unreadFetchTimer = null;
    }
  },
  methods: {
    openDrawer() {
      this.$root.$emit("open-user-conversation");
    },
    onChatLiveEvent() {
      if (this.unreadFetchTimer) {
        clearTimeout(this.unreadFetchTimer);
      }
      this.unreadFetchTimer = setTimeout(() => {
        this.unreadFetchTimer = null;
        this.fetchChatUnreadCount();
      }, 400);
    },
    extractChatList(response) {
      const body = response && response.data ? response.data : {};
      const data = body.data;
      if (Array.isArray(data)) {
        return data;
      }
      if (data && Array.isArray(data.data)) {
        return data.data;
      }
      return [];
    },
    sumUnreadInRows(rows) {
      return (rows || []).reduce(function (sum, row) {
        if (!row) {
          return sum;
        }
        const unread =
          row.unread_count != null
            ? row.unread_count
            : row.unread != null
              ? row.unread
              : 0;
        return sum + (Number(unread) || 0);
      }, 0);
    },
    fetchTypeUnread(type) {
      return this.$axios
        .get(this.$endpoint + "chat", {
          params: {
            options: JSON.stringify({
              page: 1,
              itemsPerPage: 100,
              sortDesc: [true],
            }),
            sort: "newest_message",
            type: type.api,
          },
        })
        .then((response) => this.sumUnreadInRows(this.extractChatList(response)))
        .catch(() => 0);
    },
    fetchChatUnreadCount() {
      const token = ++this.unreadFetchToken;
      Promise.all(CHAT_TYPES.map((type) => this.fetchTypeUnread(type)))
        .then((parts) => {
          if (token !== this.unreadFetchToken) {
            return;
          }
          const total = (parts || []).reduce(function (sum, n) {
            return sum + (Number(n) || 0);
          }, 0);
          this.$store.commit("SET_CHAT_UNREAD_COUNT", total);
        })
        .finally(() => {
          if (this.initialUnreadReady) {
            return;
          }
          this.initialUnreadReady = true;
          if (this.$root) {
            this.$root.$emit("chat-unread-baseline-ready");
          }
        });
    },
  },
};
</script>

<style scoped>
::v-deep .v-badge__badge {
  right: 6px !important;
  top: -8px !important;
  font-size: 9px !important;
  height: 14px !important;
  min-width: 14px !important;
  width: auto;
  padding: 0 4px !important;
  line-height: 14px !important;
}

.appbar-touchable__btn {
  width: 40px !important;
  height: 40px !important;
  margin: 0 !important;
  border-radius: 8px !important;
}

.appbar-touchable__btn:active {
  background: rgba(69, 90, 100, 0.08) !important;
}

.appbar-touchable ::v-deep .v-badge__badge {
  right: 4px !important;
  top: -2px !important;
}
</style>
